import { render, staticRenderFns } from "./UpdateIdDocument.vue?vue&type=template&id=38e35bc8&scoped=true"
import script from "./UpdateIdDocument.vue?vue&type=script&lang=js"
export * from "./UpdateIdDocument.vue?vue&type=script&lang=js"
import style0 from "./UpdateIdDocument.vue?vue&type=style&index=0&id=38e35bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e35bc8",
  null
  
)

export default component.exports